import { render } from "./HandwritingSample.vue?vue&type=template&id=470bf51a&scoped=true"
import script from "./HandwritingSample.vue?vue&type=script&lang=js"
export * from "./HandwritingSample.vue?vue&type=script&lang=js"

import "./HandwritingSample.vue?vue&type=style&index=0&id=470bf51a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470bf51a"]])

export default __exports__